import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  AdminLoginRequest,
  AdminLoginResponse,
  AdminNonceRequest,
  AdminNonceResponse,
} from '../interfaces/admin-auth.interface';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.API_BASE_URL.replace(/\/$/, '');
  
  getAdminNonce(walletAddress: string): Observable<AdminNonceResponse> {
    const body: AdminNonceRequest = { walletAddress };
    return this.http.post<AdminNonceResponse>(
      `${this.baseUrl}/admin-auth/nonce`,
      body,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  adminLogin(nonceToken: string, signature: string): Observable<AdminLoginResponse> {
    const body: AdminLoginRequest = { signature };

    return this.http.post<AdminLoginResponse>(
      `${this.baseUrl}/admin-auth/login`,
      body,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${nonceToken}`,
        }),
      }
    );
  }

  /**
   * Call the backend logout endpoint.
   * The server will clear the session and CSRF cookies.
   */
  adminLogout(): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/admin-auth/logout`,
      {},
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }
}
